import PropTypes from "prop-types";
import { classNamePropType } from "../../common";

/**
 * PropTypes for Loading component
 *
 * @property {('small'|'medium'|'large')} [size] - Loading spinner size
 * @property {string} [className] - Additional CSS classes
 * @property {string} [message] - Loading message text
 * @property {boolean} [fullScreen] - Display as full-screen overlay
 */
export const loadingPropTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: classNamePropType,
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
};
